































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DocumentInjectedData, DocumentInjectedEvidence, DocumentInjectedObject, IReplaceParameters } from "../../../../../domain/document";
import { IItem } from "../../../../../domain/document/items";
import { ModelEditableMixin, TabContainableMixin } from "../../../../system/mixins";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { EditingDocument } from "../..";
import { ITabDefinition } from "./ITabDefinition";
import { InjectedObjectList, InjectedObjectEvidenceListDialog } from "./injected";
import { InjectedObjectGroundModel, InjectedObjectModel } from "./injected/models";

@Component({
  components: {
    InjectedObjectList,
    InjectedObjectEvidenceListDialog,
  }
})
export default class InjectedTool extends Mixins<ModelEditableMixin & TabContainableMixin>(ModelEditableMixin, TabContainableMixin) {
  static readonly Tabs: {[key: string]: ITabDefinition} = {
    detail: {
      name: "詳細",
      description: "注入された値の詳細を表示します。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly detailTab: any = InjectedTool.Tabs.detail;

  $refs!: {
    evidenceListDialog: InjectedObjectEvidenceListDialog,
  };

  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  @Prop()
  source: IDrawableItemEditable;

  @Prop({ default: "right" })
  containerTabPosition: string;

  data() {
    return {
      isLoading: false,
    };
  }
  isLoading: boolean;

  get items(): IItem[] {
    return this.readPropertyOrDefault(s => s.items, []);
  }

  get shouldMarkInjected(): boolean {
    return this.readPropertyOrDefault(s => s.shouldMarkInjected, false);
  }

  set shouldMarkInjected(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldMarkInjected = value);
  }

  get injectedData(): DocumentInjectedData {
    const result = this.readPropertyOrDefault(s => s.injectedData, null);
    return result || this._emptyInjectedData; // 存在しない場合は空で補完.(そもそも表示されないはずだが念の為.)
  }

  private readonly _emptyInjectedData = new DocumentInjectedData([], []);

  get sources(): DocumentInjectedObject[] {
    return this.injectedData.objects;
  }

  get evidences(): DocumentInjectedEvidence[] {
    return this.injectedData.evidences;
  }

  get informations(): InjectedObjectModel[] {
    return this.sources.map(s => ({
      source: s,
      grounds: s.grounds.map(g => ({
        ground: g,
        evidences: this.evidences.filter(e => e.key === g.evidenceKey),
      })),
      target: this.readPropertyOrDefault(d => d.findInjectedItem(s), null),
    }));
  }

  get isReliable(): boolean {
    return this.informations.every(m => m.grounds.every(g => this.isGroundReliable(g)));    
  }

  isGroundReliable(source: InjectedObjectGroundModel): boolean {
    return source.ground.isReliable
        && source.evidences.every(e => e.isReliable);
  }

  get replaceParameters(): IReplaceParameters {
    return this.readPropertyOrDefault(s => ({
      masterCode: s.attributes.format.masterCode,
      formatOriginalId: s.attributes.format.originalId,
      patientId: s.attributes.patient.id,
      userId: this.$store.getters.user.id,
    }), {
      masterCode: "",
      formatOriginalId: 0,
      patientId: "",
      userId: "",
    });
  }

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.detailTab,
    ];
  }

  get isLayoutHorizontal(): boolean {
    return (this.containerTabPosition === "top")
        || (this.containerTabPosition === "bottom");
  }

  get tabLayoutClass(): string {
    return this.isLayoutHorizontal
      ? "horizontal"
      : "vertical";
  }

  get tabPosition(): string {
    return this.isLayoutHorizontal
      ? "left"
      : "top";
  }

  async showEvidenceList() {
    await this.$refs.evidenceListDialog.show(this.evidences);
  }

  onClicked(index: number) {
    const target = this.informations[index].target;
    if (target) {
      this.writePropertyWhenValid(s => {
        s.updateFocusedItem(0, target);
      });
    }
  }

  @Watch("tabPosition")
  async onTabPositionChanged() {
    // keep-aliveタグの子のコンポーネントのactivatedを動作させるためisTransitioningを一度切り替える
    this.isTransitioning = true;
    await this.$nextTick();
    this.isTransitioning = false;
  }
}
